import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../const";
import _ from 'lodash';
import { unAuthorized }  from '../../../../auth/Auth.ducks'
import { Service } from "../../../../service/service"

// Messagerie fiche actions

export const GET_MESSAGERIEFICHE_PENDING = "GET_MESSAGERIEFICHE_PENDING";
export const GET_MESSAGERIEFICHE_REJECTED = "GET_MESSAGERIEFICHE_REJECTED";
export const GET_MESSAGERIEFICHE_FULFILLED = "GET_MESSAGERIEFICHE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case GET_MESSAGERIEFICHE_PENDING:
      return true;
    case GET_MESSAGERIEFICHE_REJECTED:
    case GET_MESSAGERIEFICHE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_MESSAGERIEFICHE_PENDING:
    case GET_MESSAGERIEFICHE_FULFILLED:
      return null;
    case GET_MESSAGERIEFICHE_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_MESSAGERIEFICHE_FULFILLED:
      return _.isEmpty(payload.data) ? [] : payload.data.messages;
    default:
      return [];
  }
};

// MESSAGERIEFICHE reducer
export default combineReducers({ loading, error, data });

export const getMessagerieFicheSimple = (tok,id) => {
  return (dispatch) => {
    dispatch({ type: GET_MESSAGERIEFICHE_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants/${id}/messages`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_MESSAGERIEFICHE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_MESSAGERIEFICHE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}